import {getUserToken, logout} from '../../../api/users'
import * as authTypes from './types'
import * as userTypes from '../user/types'

export function loginUser({commit}, user) {
  return new Promise((resolve, reject) => {
    getUserToken(user)
      .then(({data}) => {
        commit(authTypes.TOKEN, data.token)
        commit(userTypes.SET_USER, data.user)

        resolve(data)
      })
      .catch((errors) => {
        reject(errors)
      })
  })
}

export function logoutUser({commit}, token) {
  return new Promise((resolve, reject) => {
    logout(token)
      .then((data) => {
        commit(authTypes.TOKEN, null)
        commit(userTypes.SET_USER, null)
        resolve(data)
      })
      .catch((errors) => {
        
        reject(errors)
      })
  })
}

export function setPatientToken({commit}, token) {
  commit(authTypes.PATIENT_TOKEN, token)
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/auth/actions.js
// module id = null
// module chunks = 